import app from '../firebase';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { useState, useEffect } from 'react';

export default function Services() {

    const [services, setServices] = useState();
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });

    const getServices = async () => {
        let x = [];
        
        await getDocs(collection(getFirestore(app), 'services'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        
        setServices(x);
    }

    useEffect(() => {
        getServices();
    }, []);

    return(
        <>
            <div className="container-fluid min-vh-100 bg-light p-4">
                <h2 className='mb-4'>Services</h2>
                <div className="row g-2">
                    {
                        services && services.map(i => (
                            <a href={`service/${i[0]}`} className="col-md-2">
                                <div className="h-100 rounded-3 border">
                                    <img src={i[1].image_url} className="img-fluid mb-2" alt={i[1].title} />
                                    <small className="d-block text-center">{i[1].name.substring(0, 26)}</small>
                                    <small className="d-block text-center text-success fw-bold">{formatter.format(i[1].price)}</small>
                                </div>
                            </a>
                        ))
                    }
                </div>
            </div>

        </>
    )
}